import React from 'react'
import "./buffers.scss"

function QrCodes({currentLocale}) {
  return (
    <div id="qr-codes-buffer">
      <div className="group">
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (1).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (2).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (3).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (4).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (5).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (6).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (7).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (8).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (9).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (10).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (11).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (12).png`} alt=""/>
          </div>
      </div>
      <div className="group">
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (1).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (2).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (3).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (4).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (5).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (6).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (7).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (8).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (9).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (10).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (11).png`} alt=""/>
          </div>
          <div className="qr-code">
            <img src={`images/buffers-${currentLocale}/qr-codes/img (12).png`} alt=""/>
          </div>
      </div>
    </div>
  )
}

export default QrCodes
